/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { reduxForm } from 'redux-form/immutable';
import IntegrationListenerLayout from './layout';
import {
  setSelectedSubEntityId,
} from '../../../../redux/modules/entities';
import { isSubEntitySaving } from '../../../../redux/modules/entities/selectors';
import {
  subEntityFormSubmission,
  selectIntegrationListenerFormInitialValues,
  selectIntegrationsFormInitialValues,
  getGoogleOauthClientId,
  getGoogleOauthClientSecret,
  getMsOauthClientId,
  getMsOauthClientSecret,
  getMsOauthPreferredUsernameListener,
} from '../../../../redux/modules/entities/integrations/selectors';
import {
  getCurrentFormValueByFieldName,
  getCurrentSubFormValueByFieldName,
} from '../../../../redux/modules/form/selectors';
import { formValidation } from './validation';

const CreateIntegrationListenerForm = reduxForm({
  form: 'integrationListener:create',
  onSubmit: subEntityFormSubmission,
  validate: formValidation
})(IntegrationListenerLayout);

export function mapStateToProps(state) {
  const properties = getCurrentFormValueByFieldName(state, 'properties');
  const subFormProperties = getCurrentSubFormValueByFieldName(state, 'integrationListener:create', 'properties');
  return {
    currentEmail: subFormProperties && subFormProperties.get('email'),
    googleOauthClientId: getGoogleOauthClientId(state),
    googleOauthClientSecret: getGoogleOauthClientSecret(state),
    incomingType: properties && properties.get('incomingType'),
    initialValues: selectIntegrationListenerFormInitialValues(state),
    integrationEmail: properties && properties.get('smtpUser'),
    integrationInitialValues: selectIntegrationsFormInitialValues(state),
    integrationType: getCurrentFormValueByFieldName(state, 'type'),
    isSaving: isSubEntitySaving(state),
    key: 'create',
    msOauthClientId: getMsOauthClientId(state),
    msOauthClientSecret: getMsOauthClientSecret(state),
    msOauthPreferredUsernameListener: getMsOauthPreferredUsernameListener(state),
    oauthCredential: properties && properties.get('oauthCredential'),
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    onCancel: () => {
      dispatch(setSelectedSubEntityId(undefined));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateIntegrationListenerForm);
